/**
 * Log API requests and their response codes on the client side
 * @param method HTTP method of the request
 * @param url URL of the request
 * @param status HTTP status code of the response
 * @param error Optional error message if the request failed
 */
export function logAPICall(
  method: string,
  url: string,
  status?: number,
  error?: string,
) {
  if (error) {
    console.error(
      `API ${method} ${url} - Status: ${status || "ERROR"} - Error: ${error}`,
    );
  } else if (status) {
    console.info(`API ${method} ${url} - Status: ${status}`);
  } else {
    console.info(`API Request: ${method} ${url}`);
  }
}
